import tcWrap from '../../utilities/generic-helpers/tcWrap'
import {apiClient} from '../client'
import handleError from '../../utilities/api-helpers/handleError'

export const fetchCaseTypes = (category = 'membercases page') => tcWrap(async () => {
  const {case_types, meta: {total}} = await apiClient.get('cases/types', {params: {category}}).catch(handleError)
  return {case_types, total}
})
